module.exports = __webpack_public_path__ + "static/media/calendar191e7bc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/calendar.svg
// module id = 350
// module chunks = 0